import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';

import {
  Form,
  Select,
  InputNumber,
} from 'antd';
import { Providers, TransactionTypesArray } from '../../constants/System';

const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const MerchantBeneficiaryForm = ({
  form,
  handleChange,
  minimumAmount,
  maximumAmount,
  handleChangeProviders,
  selectedProviders,
  handleChangeTransactionTypes,
  selectedTransactionTypes,
}) => {
  const selectedMerchant = useSelector(({ data }) => data.selectedMerchantAccount);
  const providerOptions = Providers && Providers.map((provider) => (
    <Option className="gx-text-capitalize" key={provider}>{provider}</Option>));
  const transactionTypesOptions = TransactionTypesArray && TransactionTypesArray.map((transactionType) => (
    <Option className="gx-text-capitalize" key={transactionType}>{transactionType}</Option>));

  return (
    <Form
      name="basic"
      className="gx-form-row0"
      ref={form}
      {...formItemLayout}
    >
      <Form.Item
        rules={[
          { required: true, message: 'This input is required!' },
        ]}
        label="Merchant"
      >
        {selectedMerchant.name}
      </Form.Item>
      <Form.Item
        rules={[
          { required: false },
        ]}
        label="Transaction type"
      >
        <Select
          style={{ width: '100%' }}
          placeholder="Select allowed transaction type"
          value={selectedTransactionTypes}
          onChange={handleChangeTransactionTypes}
        >
          {transactionTypesOptions}
        </Select>
      </Form.Item>
      <Form.Item
        rules={[
          { required: false },
        ]}
        label="Providers"
      >
        <Select
          style={{ width: '100%' }}
          placeholder="Select allowed providers"
          value={selectedProviders}
          onChange={handleChangeProviders}
        >
          {providerOptions}
        </Select>
      </Form.Item>
      <Form.Item label="Minimum Amount">
        <Select
          name="minimum_amount"
          value={minimumAmount}
          onChange={(e) => handleChange(e, 'minimum_amount')}
        >
          <Option key={0}>0</Option>
          <Option key={1}>1</Option>
          <Option key={5}>5</Option>
          <Option key={10}>10</Option>
          <Option key={20}>20</Option>
          <Option key={50}>50</Option>
          <Option key={100}>100</Option>
          <Option key={200}>200</Option>
          <Option key={300}>300</Option>
          <Option key={400}>400</Option>
          <Option key={500}>500</Option>
          <Option key={1000}>1000</Option>
          <Option key={2000}>2000</Option>
          <Option key={3000}>3000</Option>
          <Option key={5000}>5000</Option>
          <Option key={10000}>10000</Option>
          <Option key={15000}>15000</Option>
          <Option key={20000}>20000</Option>
          <Option key={60000}>60000</Option>
          <Option key={500000}>500000</Option>
          <Option key={1000000}>1000000</Option>
        </Select>
      </Form.Item>
      <Form.Item label="Maximum Amount">
        <Select
          name="maximum_amount"
          value={maximumAmount}
          onChange={(e) => handleChange(e, 'maximum_amount')}
        >
          <Option key={0}>0</Option>
          <Option key={50}>50</Option>
          <Option key={100}>100</Option>
          <Option key={500}>500</Option>
          <Option key={1000}>1000</Option>
          <Option key={2000}>2000</Option>
          <Option key={3000}>3000</Option>
          <Option key={5000}>5000</Option>
          <Option key={10000}>10000</Option>
          <Option key={15000}>15000</Option>
          <Option key={20000}>20000</Option>
          <Option key={60000}>60000</Option>
          <Option key={500000}>500000</Option>
          <Option key={1000000}>1000000</Option>
          <Option key={2000000}>2000000</Option>
          <Option key={3000000}>3000000</Option>
          <Option key={3500000}>3500000</Option>
          <Option key={4000000}>4000000</Option>
          <Option key={4500000}>4500000</Option>
          <Option key={5000000}>5000000</Option>
        </Select>
      </Form.Item>
      <Form.Item
        label="Fixed Charge"
        name="fixed_charge"
      >
        <InputNumber
          style={{ width: '100%' }}
          step={1}
        />
      </Form.Item>
      <Form.Item
        label="Percentage Charge"
        name="percentage_charge"
      >
        <InputNumber
          style={{ width: '100%' }}
          precision={2}
          step={0.1}
          max={100}
        />
      </Form.Item>
    </Form>
  );
};

MerchantBeneficiaryForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  minimumAmount: PropTypes.number,
  maximumAmount: PropTypes.number,
  handleChangeProviders: PropTypes.func.isRequired,
  selectedProviders: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

MerchantBeneficiaryForm.defaultProps = {
  form: {},
  minimumAmount: 0,
  maximumAmount: 0,
};

export default MerchantBeneficiaryForm;
